"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommunityInvitationLinkArgsValidator = exports.getCommunityInvitationLinkArgsSchema = exports.getInvitationLinkArgsValidator = exports.getInvitationLinkArgsSchema = exports.deleteInvitationLinkArgsValidator = exports.deleteInvitationLinkArgsSchema = exports.createInvitationLinkArgsValidator = exports.createInvitationLinkArgsSchema = exports.createInvitationLinkFromArgs = void 0;
var members_1 = require("./members");
var suretype_1 = require("suretype");
var common_1 = require("../common");
// ==========================
// utils
// ==========================
function addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
}
function createInvitationLinkFromArgs(args, community) {
    var _a;
    var createdOn = new Date();
    var expiresOn = args.expiresAfterMinutes ? addMinutes(createdOn, args.expiresAfterMinutes) : null;
    return {
        details: {
            name: community.details.name,
            shortDescription: community.details.shortDescription
        },
        // sort
        createdOn: createdOn.getTime(),
        expiresOn: (_a = expiresOn === null || expiresOn === void 0 ? void 0 : expiresOn.getTime()) !== null && _a !== void 0 ? _a : null,
        // filter
        communityId: args.communityId,
        role: args.role,
    };
}
exports.createInvitationLinkFromArgs = createInvitationLinkFromArgs;
// ==========================
// actions
// ==========================
// create invitation link
exports.createInvitationLinkArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("createInvitationLink").required(),
    invitationId: common_1.idSchema.required(),
    expiresAfterMinutes: suretype_1.v.anyOf([suretype_1.v.number().gt(0), suretype_1.v.null()]).required(),
    communityId: common_1.idSchema.required(),
    role: members_1.memberRolesSchema.required(),
});
exports.createInvitationLinkArgsValidator = (0, suretype_1.compile)(exports.createInvitationLinkArgsSchema);
// delete invitation link
exports.deleteInvitationLinkArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("deleteInvitationLink").required(),
    invitationId: common_1.idSchema.required()
});
exports.deleteInvitationLinkArgsValidator = (0, suretype_1.compile)(exports.deleteInvitationLinkArgsSchema);
// get invitation link
// NOTE it is important to restrict access to invitation links via cloud functions
// to prevent hackers from querying all invitation links
exports.getInvitationLinkArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("getInvitationLink").required(),
    invitationId: common_1.idSchema.required()
});
exports.getInvitationLinkArgsValidator = (0, suretype_1.compile)(exports.getInvitationLinkArgsSchema);
// query invitation link with role and communityId
// NOTE this function can only be called by the administrator
exports.getCommunityInvitationLinkArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("getCommunityInvitationLink").required(),
    communityId: common_1.idSchema.required(),
    role: members_1.memberRolesSchema.required(),
});
exports.getCommunityInvitationLinkArgsValidator = (0, suretype_1.compile)(exports.getCommunityInvitationLinkArgsSchema);
